// extracted by mini-css-extract-plugin
export default {"container":"Form_container__WXj-7","form":"Form_form__e1yzW","error":"Form_error__Roa6G","good":"Form_good__4KLt0","back":"Form_back__0ZMua"};